/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 M NaCl (MW 58.44) in 1 L: mass = 1 M × 1 L × 58.44 g/mol = 58.44 g.`)
};

const es_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 M de NaCl (PM 58.44) en 1 L: masa = 1 M × 1 L × 58.44 g/mol = 58.44 g.`)
};

const de_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 M NaCl (MW 58,44) in 1 L: Masse = 1 M × 1 L × 58,44 g/mol = 58,44 g.`)
};

const nl_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 M NaCl (MW 58,44) in 1 L: massa = 1 M × 1 L × 58,44 g/mol = 58,44 g.`)
};

const fr_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 M de NaCl (MM 58,44) dans 1 L : masse = 1 M × 1 L × 58,44 g/mol = 58,44 g.`)
};

const it_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 M di NaCl (PM 58,44) in 1 L: massa = 1 M × 1 L × 58,44 g/mol = 58,44 g.`)
};

const pt_br2_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NaCl 1 M (MM 58,44) em 1 L: massa = 1 M × 1 L × 58,44 g/mol = 58,44 g.`)
};

const pt_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 M de NaCl (MM 58,44) em 1 L: massa = 1 M × 1 L × 58,44 g/mol = 58,44 g.`)
};

const ja_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 L中の1 M NaCl (分子量58.44): 質量 = 1 M × 1 L × 58.44 g/mol = 58.44 g。`)
};

const zh_massmol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 L 中配制 1 M NaCl（分子量 58.44）：质量 = 1 M × 1 L × 58.44 g/mol = 58.44 g。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_ex1", locale)
	if (locale === "en") return en_massmol_ex1(inputs)
	if (locale === "es") return es_massmol_ex1(inputs)
	if (locale === "de") return de_massmol_ex1(inputs)
	if (locale === "nl") return nl_massmol_ex1(inputs)
	if (locale === "fr") return fr_massmol_ex1(inputs)
	if (locale === "it") return it_massmol_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_ex1(inputs)
	if (locale === "pt") return pt_massmol_ex1(inputs)
	if (locale === "ja") return ja_massmol_ex1(inputs)
	return zh_massmol_ex1(inputs)
};